import React from "react";
import Button from "@mui/material/Button";
import InputBase from "@mui/material/InputBase";
import InstaColors, {
  fontFamily,
  reviewScreenButtonWithColor,
  screenHeaderStyle,
  searchBoxStyle,
  useSharedValue,
} from "../../Constants/constants";

export default function AdminSystemLinks() {
  const { isMenuOpen } = useSharedValue();
  const [importUrl, setURL] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [exportUrl, setExportURL] = React.useState("");
  const [exportPassword, setExportPassword] = React.useState("");

  return (
    <div style={screenHeaderStyle(isMenuOpen)}>
      <div
        style={{
          backgroundColor: "white",
          marginTop: "6px",
          height: "54px",
          paddingTop: "26px",
          alignItems: "center",
          marginLeft: "20px",
          marginRight: "20px",
          borderRadius: "3px",
        }}
      >
        <div
          style={{
            display: "inline-block",
            width: "180px",
            fontSize: 15,
            fontFamily: fontFamily, // Add this line
            fontWeight: 500,
            textAlign: "left",
            color: "black",
            marginLeft: "10px",
            marginRight: "10px",
          }}
        >
          ADMINISTRATION PAGE
        </div>
      </div>
      <div
        style={{
          backgroundColor: "white",
          marginTop: "2px",
          marginLeft: "20px",
          marginRight: "20px",
          borderRadius: "3px",
        }}
      >
        <div style={{ padding: "10px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span
              style={{
                color: "black",
                marginRight: "10px",
                width: "220px",
                fontSize: 15,
                fontFamily: fontFamily, // Add this line
                fontWeight: 400,
              }}
            >
              Comply Admin - Import Page URL
            </span>
            <InputBase
              value={importUrl}
              onChange={(e) => setURL(e.target.value)}
              style={searchBoxStyle}
              inputProps={{ "aria-label": "Entity Search", style: { padding: "0 8px" } }}
            />
            <span
              style={{
                color: "black",
                marginLeft: "20px",
                width: "80px",
                fontSize: 15,
                fontFamily: fontFamily, // Add this line
                fontWeight: 400,
              }}
            >
              Password
            </span>
            <InputBase
              value={password}
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              style={searchBoxStyle}
              autoComplete="off"
              // placeholder="Password"
              inputProps={{
                "aria-label": "Password Input",
                style: { padding: "0 8px" },
                autoComplete: "off",
              }}
            />
            <span
              style={{
                textDecoration: "underline",
                color: InstaColors.primary,
                marginLeft: "10px",
                fontSize: 14,
                fontFamily: fontFamily, // Add this line
                fontWeight: 400,
              }}
            >
              TEST
            </span>
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundColor: "white",
          marginTop: "2px",
          marginLeft: "20px",
          marginRight: "20px",
          borderRadius: "3px",
        }}
      >
        <div style={{ padding: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
            <span
              style={{
                color: "black",
                marginRight: "10px",
                width: "220px",
                fontSize: 15,
                fontFamily: fontFamily, // Add this line
                fontWeight: 400,
              }}
            >
              Comply Admin - Export to URL
            </span>
            <InputBase
              value={exportUrl}
              onChange={(e) => setExportURL(e.target.value)}
              style={searchBoxStyle}
              inputProps={{ "aria-label": "Entity Search", style: { padding: "0 8px" } }}
            />
            <span
              style={{
                color: "black",
                marginLeft: "20px",
                width: "80px",
                fontSize: 15,
                fontFamily: fontFamily, // Add this line
                fontWeight: 400,
              }}
            >
              Password
            </span>
            <InputBase
              value={exportPassword}
              type="password"
              onChange={(e) => setExportPassword(e.target.value)}
              style={searchBoxStyle}
              autoComplete="off"
              // placeholder="Password"
              inputProps={{
                "aria-label": "Password Input",
                style: { padding: "0 8px" },
                autoComplete: "off",
              }}
            />
            <span
              style={{
                textDecoration: "underline",
                color: InstaColors.primary,
                marginLeft: "10px",
                fontSize: 14,
                fontFamily: fontFamily, // Add this line
                fontWeight: 400,
              }}
            >
              TEST
            </span>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", marginRight: 100 }}>
            <Button variant="contained" style={reviewScreenButtonWithColor(100)}>
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
